import type { DashboardPayload, FuelType, HistoryPoint, ProductData } from "./types";

const productConfig: Array<{
  fuelType: FuelType;
  label: string;
  recovery: number;
}> = [
  { fuelType: "petrol_95", label: "Petrol 95", recovery: 42.8 },
  { fuelType: "petrol_93", label: "Petrol 93", recovery: 39.2 },
  { fuelType: "diesel_500ppm", label: "Diesel 500ppm", recovery: -27.5 },
  { fuelType: "diesel_50ppm", label: "Diesel 50ppm", recovery: -31.1 },
  { fuelType: "illuminating_paraffin", label: "Illuminating paraffin", recovery: -18.4 },
];

const variation = [-13, -10, -7, -4, -8, -2, 1, 4, 2, 7, 10, 8, 13, 16, 14, 18];

function historyFor(finalValue: number): HistoryPoint[] {
  return variation.map((offset, index) => {
    const date = new Date(Date.UTC(2026, 6, index + 2));
    const progress = (index + 1) / variation.length;
    const recoveryCents = finalValue * progress + offset;
    return {
      date: date.toISOString().slice(0, 10),
      recoveryCents: Number(recoveryCents.toFixed(1)),
      dailyRecoveryCents: Number((recoveryCents + offset * 0.7).toFixed(1)),
    };
  });
}

const products: ProductData[] = productConfig.map(({ fuelType, label, recovery }) => {
  const history = historyFor(recovery);
  const predictedChange = Number((-recovery * 1.08).toFixed(1));
  return {
    fuelType,
    label,
    history,
    latest: {
      fuelType,
      recordDate: "2026-07-17",
      cycleStart: "2026-06-26",
      dailyRecoveryCents: history.at(-1)?.dailyRecoveryCents ?? recovery,
      averageRecoveryCents: recovery,
      sourceUrl: "https://cefgroup.co.za/daily-basic-fuel-price/",
      ingestedAt: "2026-07-17T16:10:00Z",
    },
    prediction: {
      fuelType,
      generatedAt: "2026-07-17T16:15:00Z",
      cycleStart: "2026-06-26",
      targetDate: "2026-08-05",
      predictedChangeCents: predictedChange,
      rangeLowCents: Number((predictedChange - 10.5).toFixed(1)),
      rangeHighCents: Number((predictedChange + 10.5).toFixed(1)),
      confidence: "medium",
      confidenceScore: 68,
      direction:
        predictedChange > 2 ? "increase" : predictedChange < -2 ? "decrease" : "stable",
      observedDays: 16,
      expectedDays: 22,
      latestRecoveryCents: recovery,
      method: "recency_weighted_cycle_projection_v1",
    },
  };
});

export const demoDashboard: DashboardPayload = {
  updatedAt: "2026-07-17T16:10:00Z",
  predictionGeneratedAt: "2026-07-17T16:15:00Z",
  targetDate: "2026-08-05",
  products,
  source: {
    name: "Central Energy Fund (CEF)",
    url: "https://cefgroup.co.za/daily-basic-fuel-price/",
  },
  disclaimer: "Sample preview only — these values are not a current fuel-price forecast.",
};
